import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Trip from 'affiliates/Widget/FerrySearchMask/MultiTrip/Trip';
import SearchButton from 'components/SearchMask/SearchButton';

const MultiTrip = ({
  isMobile, loading, triedToSubmit, brandLogo, trips, noOfTrips, minTrips, maxTrips, popular, joinProgram,
  errors, addTrip, removeTrip,setPort, fetchSuggestions, clearSuggestions, onSuggestionSelected, portString,
  portStringNo3Ltr, swapPorts, setTypeTrip, setDate, setDates, setPortByThreeLetterCode, submitForm, product,
  translations
}) => (
  <form className="searchMask multi-trip">
    <div className="grid no-gutter">
      {trips.map((trip, index) =>
        <Trip
          key={index}
          isMobile={isMobile}
          index={index}
          triedToSubmit={triedToSubmit}
          trip={trip}
          noOfTrips={noOfTrips}
          minTrips={minTrips}
          maxTrips={maxTrips}
          popular={popular}
          errors={errors}
          disableBefore={index > 0 && index - 1 < trips.length && trips[index - 1] ?
            trips[index - 1].obDate : {}}
          disableAfter={index >= 0 && index + 1 < trips.length && trips[index + 1] ? 
            trips[index + 1].obDate : {}}
          setPort={setPort}
          fetchSuggestions={fetchSuggestions}
          clearSuggestions={clearSuggestions}
          onSuggestionSelected={onSuggestionSelected}
          portString={portString}
          portStringNo3Ltr={portStringNo3Ltr}
          swapPorts={swapPorts}
          setTypeTrip={setTypeTrip}
          setDate={setDate}
          setDates={setDates}
          addTrip={addTrip}
          removeTrip={removeTrip}
          setPortByThreeLetterCode={setPortByThreeLetterCode}
          translations={translations}
        />
      )}
      <div className="grid no-gutter bottom-aff">
        <div className="grid-item d-flex flex-column justify-content-center">
          <img
            src={brandLogo}
            alt='logo'
            title='logo'
            width='130px'
          />
          {
            joinProgram &&
              <div>
                <a
                  className="text-small"
                  href="https://ferryscanner.tapfiliate.com/programs/ferryscanner-affiliate-program/signup/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {translations.joinFSAffiliateProgram}    
                </a>
              </div>
          }
        </div>
        <SearchButton
          multiTrip
          breakpoint="md"
          product={product}
          loading={loading}
          submitForm={submitForm}
          translations={translations}
        />
      </div>
    </div>
  </form>
);

MultiTrip.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  triedToSubmit: PropTypes.bool.isRequired,
  product: PropTypes.string.isRequired,
  brandLogo: PropTypes.string.isRequired,
  trips: PropTypes.object.isRequired,
  noOfTrips: PropTypes.number.isRequired,
  minTrips: PropTypes.number.isRequired,
  maxTrips: PropTypes.number.isRequired,
  popular: PropTypes.bool.isRequired,
  joinProgram: PropTypes.bool.isRequired,
  errors: PropTypes.array.isRequired,
  addTrip: PropTypes.func.isRequired,
  removeTrip: PropTypes.func.isRequired,
  setPort: PropTypes.func.isRequired,
  fetchSuggestions: PropTypes.func.isRequired,
  clearSuggestions: PropTypes.func.isRequired,
  onSuggestionSelected: PropTypes.func.isRequired,
  portString: PropTypes.func.isRequired,
  portStringNo3Ltr: PropTypes.func.isRequired,
  swapPorts:PropTypes.func.isRequired,
  setTypeTrip: PropTypes.func.isRequired,
  setDate: PropTypes.func.isRequired,
  setDates: PropTypes.func.isRequired,
  setPortByThreeLetterCode: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired
};

export default observer(MultiTrip);
